// Per-page background video assets. Adding more pages = add an entry below
// and import on the relevant page component.
export const BG_VIDEOS = {
  directory:
    "https://customer-assets.emergentagent.com/job_b515077c-a195-4ba1-b1ea-7a33c6e19b28/artifacts/07j7x276_kling_20260520_Image_to_Video_Make_like__1065_0.mp4",
  marketplace:
    "https://customer-assets.emergentagent.com/job_b515077c-a195-4ba1-b1ea-7a33c6e19b28/artifacts/z81rs5j2_kling_20260520_Image_to_Video_Make_like__1027_0.mp4",
  howItWorks:
    "https://customer-assets.emergentagent.com/job_b515077c-a195-4ba1-b1ea-7a33c6e19b28/artifacts/wsnjv2xl_kling_20260520_Image_to_Video_Make_like__1105_0.mp4",
};

// Hero videos with audio (autoplay muted, unmute button)
export const HERO_VIDEOS = {
  ownTheNumberOne:
    "https://customer-assets.emergentagent.com/job_b515077c-a195-4ba1-b1ea-7a33c6e19b28/artifacts/vm35fch9_Own%20The%20%231%20Spot%20-%20VEED%20Export-1779394237262.mp4",
};
